import type { IAddress } from "@bbj-types/address";
import type { IDocument } from "@bbj-types/document";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";

export interface IGetCandidateSendMailQuery {
  templateId: ObjectId;
  meeting?: {
    date?: string;
    time?: { hours: number; minutes: number };
    address?: IAddress;
    complementaryAddress?: string;
  };
}

export const usePostCandidateSendMail = () => {
  const [state, execute, cancel] = axios<IDocument, void, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, params: IGetCandidateSendMailQuery) => {
      return execute({ url: `/candidates/${id}/mail/send`, params });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
